module.exports = __webpack_public_path__ + "img/icon-thai-qr-cross-v1.78765030.png";